import React from "react";
import { StyledSpan } from "./styled";

// onClick / style / title are forwarded (2026-11-03): they used to be swallowed
// into $customStyles, so every clickable Span was dead (project page "Add on
// invoice", Instant Estimate "Undo", Client Plans tab link).
const Span = (props?: any) => {
  const { onClick, style, title, children } = props ?? {};
  return (
    <StyledSpan $customStyles={{ ...props }} onClick={onClick} style={style} title={title} role={onClick ? "button" : undefined}>
      {children}
    </StyledSpan>
  );
};

export default Span;
